var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("a-icon", { staticClass: "a-icon", attrs: { type: "plus-circle" } }),
      !_vm.disabled
        ? _c(
            "div",
            { staticClass: "ant-input", on: { click: _vm.openModal } },
            [
              _vm._l(_vm.returnValue, function (tag) {
                return [
                  _vm.type === "dept"
                    ? _c(
                        "a-tooltip",
                        { key: tag.deptId, attrs: { title: tag.deptName } },
                        [
                          _c(
                            "a-tag",
                            {
                              key: tag.deptId,
                              staticStyle: { margin: "3px" },
                              attrs: { closable: true },
                              on: {
                                close: function () {
                                  return _vm.tagClose(tag)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(tag.deptName) + " ")]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "a-tooltip",
                        { key: tag.userId, attrs: { title: tag.userName } },
                        [
                          _c(
                            "a-tag",
                            {
                              key: tag.userId,
                              staticStyle: { margin: "3px" },
                              attrs: { closable: true },
                              on: {
                                close: function () {
                                  return _vm.tagClose(tag)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(tag.userName) + " ")]
                          ),
                        ],
                        1
                      ),
                ]
              }),
              _c(
                "a-tooltip",
                { key: 1000001, attrs: { title: "删除全部" } },
                [
                  _c(
                    "a-tag",
                    {
                      key: 1000001,
                      staticStyle: { margin: "3px" },
                      attrs: { visible: _vm.returnValue.length > 0 },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.closeAll.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" 删除全部 ")]
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "ant-input" },
            [
              _vm._l(_vm.returnValue, function (tag) {
                return [
                  _vm.type === "dept"
                    ? _c(
                        "a-tooltip",
                        { key: tag.deptId, attrs: { title: tag.deptName } },
                        [
                          _c(
                            "a-tag",
                            {
                              key: tag.deptId,
                              staticStyle: { margin: "3px" },
                              attrs: { closable: false },
                              on: {
                                close: function () {
                                  return _vm.tagClose(tag)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(tag.deptName) + " ")]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "a-tooltip",
                        { key: tag.userId, attrs: { title: tag.userName } },
                        [
                          _c(
                            "a-tag",
                            {
                              key: tag.userId,
                              staticStyle: { margin: "3px" },
                              attrs: { closable: false },
                              on: {
                                close: function () {
                                  return _vm.tagClose(tag)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(tag.userName) + " ")]
                          ),
                        ],
                        1
                      ),
                ]
              }),
            ],
            2
          ),
      _c(
        "a-modal",
        {
          attrs: {
            forceRender: "",
            title: _vm.title,
            width: 1200,
            "ok-text": "确认",
            "cancel-text": "取消",
          },
          on: { ok: _vm.handleOk },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "tag-select" },
            [
              _c(
                "a-radio-group",
                {
                  on: { change: _vm.handleChange },
                  model: {
                    value: _vm.type,
                    callback: function ($$v) {
                      _vm.type = $$v
                    },
                    expression: "type",
                  },
                },
                [
                  _c("a-radio-button", { attrs: { value: "customer" } }, [
                    _vm._v(" 员工 "),
                  ]),
                  _c("a-radio-button", { attrs: { value: "dept" } }, [
                    _vm._v(" 部门 "),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                [
                  _vm.type === "customer"
                    ? _c(
                        "vxe-button",
                        {
                          staticStyle: { "margin-top": "12px" },
                          on: { click: _vm.chooseAll },
                        },
                        [_vm._v("全选可见员工")]
                      )
                    : _vm._e(),
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-top": "12px", float: "right" },
                      attrs: { type: "primary" },
                      on: { click: _vm.closeAll },
                    },
                    [_vm._v("清空已选")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      staticStyle: { "margin-top": "12px" },
                      on: { click: _vm.resetAll },
                    },
                    [_vm._v("重置列表")]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "user-box" }, [
                _c("div", { staticClass: "left" }, [
                  _c(
                    "div",
                    { staticClass: "search-box" },
                    [
                      _c("a-input", {
                        attrs: { placeholder: "搜索部门/员工" },
                        model: {
                          value: _vm.kws,
                          callback: function ($$v) {
                            _vm.kws = $$v
                          },
                          expression: "kws",
                        },
                      }),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                    ],
                    1
                  ),
                  _vm.type === "dept"
                    ? _c(
                        "div",
                        { staticClass: "tree-box" },
                        [
                          _c("a-tree", {
                            attrs: {
                              checkable: "",
                              "expanded-keys": _vm.expandedKeys,
                              "auto-expand-parent": _vm.autoExpandParent,
                              "selected-keys": _vm.selectedKeys,
                              "tree-data": _vm.treeData,
                              selectable: false,
                              replaceFields: {
                                children: "children",
                                title: "deptName",
                                key: "deptId",
                              },
                            },
                            on: { expand: _vm.onExpand, check: _vm.onSelect },
                            model: {
                              value: _vm.checkedKeys,
                              callback: function ($$v) {
                                _vm.checkedKeys = $$v
                              },
                              expression: "checkedKeys",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.type === "customer"
                    ? _c(
                        "div",
                        { staticClass: "tree-box" },
                        [
                          _vm.treeData.length
                            ? _c("Tree", {
                                attrs: {
                                  defaultExpandAll: "true",
                                  list: _vm.treeData,
                                  selectedUser: _vm.selectedUser,
                                  userName: _vm.kws,
                                  detph: 0,
                                },
                                on: { change: _vm.checkedUser },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "right" }, [
                  _c("div", [_vm._v("已选择的成员")]),
                  _vm.type === "dept"
                    ? _c(
                        "ul",
                        { staticClass: "selected" },
                        _vm._l(_vm.selectedData, function (item) {
                          return _c(
                            "li",
                            { key: item.key },
                            [
                              _c("span", [_vm._v(_vm._s(item.deptName))]),
                              _c("a-icon", {
                                attrs: { type: "close" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteItem(item.deptId)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm.type === "customer"
                    ? _c(
                        "ul",
                        { staticClass: "selected" },
                        _vm._l(_vm.selectedUser, function (item) {
                          return _c(
                            "li",
                            { key: item.userId },
                            [
                              _c("span", [_vm._v(_vm._s(item.userName))]),
                              _c("a-icon", {
                                attrs: { type: "close" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteUser(item.userId)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }